/**
 * Global event emitter for cross-component communication
 * Provides centralized event management for cart, product, notice, and wishlist events
 */

export interface IEmitterProps {
  cart: {
    get: string
    add: string
    update: string
    clear: string
    count: string
    change: string
    render: string
    complete: string
  }
  product: {
    updateVariant: string
  }
  collection: {
    count: string
  }
  notice: {
    global: string
  }
  wishlist: {
    global: string
    list: string
    change: string
  }
}

export const emitterProps: IEmitterProps = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    render: 'cart.render',
    complete: 'cart.complete'
  },
  product: {
    updateVariant: 'product.update_variant'
  },
  collection: {
    count: 'collection.count'
  },
  notice: {
    global: 'notice.global'
  },
  wishlist: {
    global: 'wishlist.global',
    list: 'wishlist.list',
    change: 'wishlist.change'
  }
}

export class GlobalEmitter {
  /**
   * Emits an event with a given name and payload.
   */
  public emit(name: string, payload: any): void {
    const event = new CustomEvent(name, { detail: payload })
    document.dispatchEvent(event)
  }

  /**
   * Subscribes to an event.
   */
  public on(name: string, callback: (e: CustomEvent<any>) => void): void {
    document.addEventListener(name, callback as EventListener)
  }

  /**
   * Unsubscribes from an event.
   */
  public off(name: string, callback: (e: CustomEvent<any>) => void): void {
    document.removeEventListener(name, callback as EventListener)
  }
}

export const globalEmitter = new GlobalEmitter()
